import { Component, computed, Input, Signal, signal, WritableSignal } from '@angular/core';
import { BatchStock, BatchStockDTO, StoreStock } from 'src/app/models/types/Product/Stock.type';
import { BatchCardComponent } from './batch-card/batch-card.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { MyStoreStockComponent } from '../view-stock/my-store-stock/my-store-stock.component';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-batch-stock',
  imports: [
    BatchCardComponent,
    MyStoreStockComponent,
    SharedModule
  ],
  templateUrl: './batch-stock.component.html',
  styleUrl: './batch-stock.component.scss'
})
export class BatchStockComponent {

  @Input('batchStock') batchStock!: BatchStockDTO;

  private _selectedStock: WritableSignal<BatchStock | null> = signal(null);
  public selectedStock: Signal<BatchStock | null> = computed(() => this._selectedStock());
  public storeStock: Signal<StoreStock | null> = computed(() => this._selectedStock()?.storeStocks || null);

  constructor(public readonly sharedService: SharedService) { }

  handleSelectStock(stock: BatchStock | null) {
    this._selectedStock.set(stock);
  }

}
